const LINKS = {
  index: "/",
  home: "/home",
  productDetails: "/products/:productId",
  notFound: "*",
};

export default LINKS;
